<template>
  <reflection-item
    :reflection="reflection"
    :isEditable="true"
  ></reflection-item>
</template>

<script>
import { ReflectionsAPI } from "@/lib/api"
import ReflectionItem from "@/components/reflections/ReflectionItem"
import EventBus from "@/lib/eventBus"

export default {
  components: { ReflectionItem },
  data: function() {
    return {
      reflection: {}
    }
  },
  methods: {
    GetReflection: function(id) {
      ReflectionsAPI.get(id).then(response => {
        this.reflection = response
      })
    },
    DeleteReflection: function(reflectionId) {
      ReflectionsAPI.delete(reflectionId).then(() => {
        EventBus.$emit("flash", {
          text: "Reflection Deleted",
          type: "info",
          visible: true
        })
        this.$router.push({
          name: "reflections"
        })
      })
    }
  },
  created() {
    this.GetReflection(this.$route.params.id)
    EventBus.$on("reflection:delete", reflectionId => {
      this.DeleteReflection(reflectionId)
    })
  },
  beforeDestroy() {
    EventBus.$off("reflection:delete")
  }
}
</script>

<style lang="css" scoped></style>
